import * as type from './types';

export function login(data) {
    return {
      type: type.POST_LOGIN_REQUESTED,
      data:data,
    }
  }